$.fn.modalGallery = function() {
  const main = $(this);
  const options = {
    images: [],
    active: false,
    activeImage: 0,
  };

  const closeGallery = () => {
    options.modal.remove();
    $(window).off('keydown.galleryModal');
  };

  const openGallery = (images) => {
    appendHtml();
    bindKeyboard();
    bindEvents();
    showImage();
  }

  const bindEvents = () => {
    options.modal.find('.galleryModal__prev').on('click', (e) => {
      e.preventDefault();
      navigate(-1);
    });
    options.modal.find('.galleryModal__next').on('click', (e) => {
      e.preventDefault();
      navigate(1);
    });
    options.modal.find('.galleryModal__close').on('click', (e) => {
      e.preventDefault();
      closeGallery();
    });
  };

  const bindKeyboard = () => {
    $(window).on('keydown.galleryModal', (e) => {
      const key = e.which || e.keyCode || 0;
      if (key === 27) {
        e.preventDefault();
        closeGallery();
      } else if (key === 37) {
        e.preventDefault();
        navigate(-1);
      } else if (key === 39) {
        e.preventDefault();
        navigate(1);
      }
    });
  }

  const navigate = (direction) => {
    options.activeImage+= direction;
    if (options.activeImage < 0) {
      options.activeImage = options.images.length - 1;
    } else if (options.activeImage >= options.images.length) {
      options.activeImage = 0;
    }
    showImage();
  };

  const showImage = () => {
    const styles = [`background-image:url(${options.images[options.activeImage]})`];
    const html = [`<div class="galleryModal__counter">${options.activeImage + 1 }/${options.images.length }</div>`];

    if (options.images[options.activeImage].match(':::')) {
      styles[0] = `background-image:url(${options.images[options.activeImage].split(':::')[0]})`;
      styles.push('background-size:cover;');
      const videoPath = options.images[options.activeImage].split(':::')[1].split('?')[1];
      const videoParams = Object.fromEntries(new URLSearchParams(videoPath));
      html.push(`
        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/${videoParams.v}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      `);
    }
    
    options.modal.find('.galleryModal__placeholder').attr({
      style: styles.join(';')
    }).html(html.join(''));
  };

  const appendHtml = () => {
    const html = /*html*/`
      <div class="galleryModal">
        <div class="galleryModal__wrapper">
          <div class="galleryModal__close"><span class="mdi mdi-close"></span></div>
          <div class="galleryModal__prev"><span class="mdi mdi-chevron-left"></span></div>
          <div class="galleryModal__next"><span class="mdi mdi-chevron-right"></span></div>
          <div class="galleryModal__placeholder"></div>
        </div>
      </div><!--/galleryModal-->
    `;
    $('body').append(options.modal = $(html));
  }

  main.off('click.galleryModal').on('click.galleryModal', (e) => {
    e.preventDefault();
    options.images = main.attr('data-images').split(',');
    options.active ? closeGallery() : openGallery();
  });

}

$.fn.imageLookChanger = function () {
  const main = $(this);
  const img = main.find('img');
  const dataWidth = img.prop("naturalWidth");
  const dataHeight = img.prop("naturalHeight");
  if ((dataWidth / dataHeight) >= 1.77) { // 16:9
    main.css("padding-bottom", "56.25%");
  }
};
